import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const sid = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sid) { navigate("/admin/login"); return; }
    (async () => {
      try {
        await api.post("/auth/google/session", {}, { headers: { "X-Session-ID": sid } });
        window.history.replaceState(null, "", "/admin");
        window.location.href = "/admin";
      } catch (e) {
        window.location.href = "/admin/login?error=" + encodeURIComponent(e?.response?.data?.detail || "auth_failed");
      }
    })();
  }, [navigate]);

  return <div className="min-h-screen grid place-items-center text-slate-400">Signing you in…</div>;
}
